import U from "classnames";
import { format as s, isSameDay as O, isSameYear as E, isSameMonth as l, startOfMonth as h, endOfMonth as F, startOfYear as i, getMonth as $, getYear as d, isAfter as g, subMonths as b, isBefore as C, addMonths as Y, endOfYear as A, subYears as H, endOfQuarter as J, startOfQuarter as k, subQuarters as q, addDays as z, subDays as G, subWeeks as m, endOfWeek as N, getDate as S, startOfWeek as I } from "date-fns";
let W = {}, P;
const D = (n, t, o, r, u = !1) => {
  if (o && (!n || !t)) return o;
  if (((r == null ? void 0 : r.activePanel) === "fixed" || (r == null ? void 0 : r.activePanel) === "relative") && r.label)
    return r.label;
  const c = u ? "MMM dd" : "MMM dd, yyyy", M = n || /* @__PURE__ */ new Date(), y = t || /* @__PURE__ */ new Date(), v = s(y, c), Q = s(M, c);
  return O(M, y) ? `${Q}` : K(M, y) ? s(M, "MMMM yyyy") : R(M, y) ? `Jan 01 - Dec 31, ${s(M, "yyyy")}` : E(M, y) ? `${s(M, "MMM dd")} - ${v}` : `${Q} - ${v}`;
}, nn = (n) => Object.values(n).map((t) => ({
  key: t.label,
  label: t.label
})), K = (n, t) => {
  const o = l(n, t), r = O(h(n), n), u = O(F(t), t);
  return o && r && u;
}, R = (n, t) => {
  const o = E(n, t), r = O(i(n), n), u = O(i(t), t);
  return o && r && u;
}, X = (n) => {
  const t = S(N(n));
  return S(n) === t ? I(n) : m(I(n), 1);
}, Z = (n) => {
  const t = S(F(n));
  return S(n) === t ? h(n) : b(h(n), 1);
}, tn = (n) => {
  const t = s(J(n), "MMMM");
  return s(n, "MMMM") === t ? k(n) : q(k(n), 1);
}, rn = (n) => {
  const t = s(A(n), "MMMM");
  return s(n, "MMMM") === t ? i(n) : H(i(n), 1);
}, j = (n, t, o) => {
  const r = X(n);
  return [m(r, t - 1), N(r)];
}, f = (n, t, o) => {
  if (o)
    return [new Date(o.start), new Date(o.end)];
  const r = Z(n);
  return [b(r, t - 1), F(r)];
}, L = (n, t) => [G(n, t - 1), n], T = (n, t) => [z(b(n, t), 1), n], _ = (n) => [h(n), n], B = (n) => [k(n), n], a = (n) => [i(n), n], w = (n, t) => ({
  "Month to Date": _(n),
  "Quarter to Date": B(n),
  "Year to Date": a(n),
  "Last full 4 weeks": j(n, 4),
  "Last full 6 weeks": j(n, 6),
  "Last full 3 months": f(n, 3, t == null ? void 0 : t["last-3-months"]),
  "Last full 6 months": f(n, 6, t == null ? void 0 : t["last-6-months"]),
  "Last full 12 months": f(n, 12, t == null ? void 0 : t["last-12-months"]),
  "Last 3 Months": f(n, 3, t == null ? void 0 : t["last-3-months"]),
  "Last 6 Months": f(n, 6, t == null ? void 0 : t["last-6-months"]),
  "Last 12 Months": f(n, 12, t == null ? void 0 : t["last-12-months"]),
  "Past 7 days": L(n, 7),
  "Past 30 days": L(n, 30),
  "Past 60 days": L(n, 60),
  "Past 90 days": L(n, 90),
  "Past 6 months": T(n, 6),
  "Past 12 months": T(n, 12)
}), on = (n, t = /* @__PURE__ */ new Date(), o) => ((!P || O(P, t)) && (P = t, W = w(t, o)), W[n]), un = (n, { selected: t, disabled: o, inCurrentMonth: r, range: u }) => U(n, u, {
  dateItemSelected: t,
  dateItemDisabled: o,
  dateItemHidden: !r
}), cn = (n, t) => {
  const o = $(t) - $(n), r = (d(t) - d(n)) * 12;
  return o + r;
}, sn = (n, t, o = /* @__PURE__ */ new Date()) => l(n, t) ? l(t, o) ? [b(n, 1), t] : [n, Y(t, 1)] : [n, t], e = (n, t, o, r = /* @__PURE__ */ new Date(), u) => {
  switch (o) {
    case "left":
      if (l(n, t) || C(t, n)) {
        const c = Y(n, 1);
        return e(n, c, "right", r, u);
      }
      return [n, t];
    case "right":
      if (l(n, t) || g(n, t)) {
        const c = b(t, 1);
        return u && C(c, h(u)) && !l(u, r) ? [t, Y(t, 1)] : [c, t];
      }
      if (g(t, r)) {
        const c = h(r);
        return e(n, c, "right", r, u);
      }
      return [n, t];
  }
}, Mn = (n, t, o) => !o || Object.keys(o).indexOf(n) === -1 ? t : t.filter(
  (r) => o[n] ? !o[n].includes(r.label) : r
);
export {
  cn as calcCalendarOffset,
  sn as calcInitViewValue,
  e as calcViewValue,
  nn as convertPresetToDateSource,
  un as getDayClassName,
  Z as getLastFullOfMonth,
  tn as getLastFullOfQuarter,
  X as getLastFullOfWeek,
  rn as getLastFullOfYear,
  on as getRelativeDateByLabel,
  K as isFullMonth,
  R as isFullYear,
  D as labelSuggestion,
  Mn as setPermittedPresetLabels
};
//# sourceMappingURL=index.es2483.js.map
